import {
    MdOutlineMap, MdOutlineEventAvailable, MdBolt, MdOutlineAccountBalanceWallet,
    MdOutlineCreditCard, MdOutlineLocationOn, MdOutlineEvStation, MdOutlineNotifications,
    MdHistory, MdInfoOutline, MdOutlineBadge, MdOutlineStarBorder,
} from 'react-icons/md';

// Keys must match the icon map in the native app (lib/screens/guide/user_guide_screen.dart)
export const GUIDE_ICONS = {
    map: { label: 'Map', Icon: MdOutlineMap },
    event: { label: 'Booking', Icon: MdOutlineEventAvailable },
    bolt: { label: 'Charging', Icon: MdBolt },
    wallet: { label: 'Wallet', Icon: MdOutlineAccountBalanceWallet },
    card: { label: 'Card', Icon: MdOutlineCreditCard },
    location: { label: 'Location', Icon: MdOutlineLocationOn },
    ev_station: { label: 'EV Station', Icon: MdOutlineEvStation },
    notifications: { label: 'Notifications', Icon: MdOutlineNotifications },
    history: { label: 'History', Icon: MdHistory },
    rfid: { label: 'RFID Card', Icon: MdOutlineBadge },
    star: { label: 'Star', Icon: MdOutlineStarBorder },
    info: { label: 'Info', Icon: MdInfoOutline },
};

export const GuideIcon = ({ name, size = 20, color }) => {
    const { Icon } = GUIDE_ICONS[name] || GUIDE_ICONS.info;
    return <Icon size={size} color={color} />;
};

// Lines starting with "-", "*" or "•" are bullets; same rule as the native app.
const BULLET_RE = /^\s*[-*•]\s+/;

export const parseGuideBody = (text = '') =>
    text.split('\n')
        .filter((line) => line.trim())
        .map((line) => BULLET_RE.test(line)
            ? { bullet: true, text: line.replace(BULLET_RE, '').trim() }
            : { bullet: false, text: line.trim() });

// **text** → bold; same rule as the native app.
export const renderInline = (text, boldColor) =>
    text.split(/\*\*(.+?)\*\*/g).map((part, i) =>
        i % 2 === 1 ? <strong key={i} style={boldColor ? { color: boldColor } : undefined}>{part}</strong> : part
    );

export const GuideBody = ({ text, className, style }) => {
    const lines = parseGuideBody(text);
    const hasBullets = lines.some((l) => l.bullet);
    return (
        <div className={className} style={{ textAlign: hasBullets ? 'left' : undefined, ...style }}>
            {lines.map((l, i) => l.bullet ? (
                <div key={i} style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                    <span>•</span><span>{renderInline(l.text)}</span>
                </div>
            ) : (
                <div key={i} style={{ marginTop: i ? 6 : 0 }}>{renderInline(l.text)}</div>
            ))}
        </div>
    );
};
